import { Tooltip } from "@mui/material";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { usersDetailsApi } from "store/api";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";

const UserDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [userDetail, setUserDetail] = useState({});
  const [userOrderProduct, setUserOrderProduct] = useState([]);
  const [userVisitProduct, setUserVisitProduct] = useState([]);
  const state = location.state;
  const containerStyle = {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    fontSize: "16px",
  };

  const redirect = data => {
    navigate("/order-details", { state: { order: data } });
  };
  const reDirect = data => {
    navigate("/product-details", { state: { productId: data.productId } });
  };
  const userDetails = async () => {
    const response = await usersDetailsApi(state);
    if (response?.success) {
      setUserDetail(response?.data?.userDetails);
      setUserOrderProduct(response?.data?.userOrderedProduct);
      setUserVisitProduct(response?.data?.userRecentVisitedProducts);
    }
  };

  const cardStyle = {
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    marginBottom: "15px",
    fontSize: "16px",
  };

  const flexRow = {
    display: "flex",
    flexWrap: "wrap",
    gap: "15px",
  };

  const flexItem = {
    flex: "1 1 calc(50% - 15px)",
    minWidth: "300px",
    fontSize: "16px",
  };

  useEffect(() => {
    if (state?.userId) userDetails();
  }, [state]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={containerStyle}>
        <h2>User Details</h2>.
        <div style={flexRow}>
          <div style={{ ...cardStyle, backgroundColor: "#f8d7da" }}>
            <p>
              <strong>Name</strong>
            </p>
            <p>{userDetail?.name}</p>
          </div>
          {userDetail?.email && (
            <div style={{ ...cardStyle, backgroundColor: "#fff3cd" }}>
              <p>
                <strong>Email</strong>
              </p>
              <p>{userDetail?.email}</p>
            </div>
          )}
          {userDetail?.number && (
            <div style={{ ...cardStyle, backgroundColor: "#d1ecf1" }}>
              <p>
                <strong>Contact No</strong>
              </p>
              <p>{userDetail?.number}</p>
            </div>
          )}
          {userDetail?.accountStatus && (
            <div style={{ ...cardStyle, backgroundColor: "#acc2cf" }}>
              <p>
                <strong>Account Status</strong>
              </p>
              <p style={{ textTransform: "capitalize" }}>{userDetail?.accountStatus}</p>
            </div>
          )}
          {userDetail?.loginType && (
            <div style={{ ...cardStyle, backgroundColor: "#9edcc1" }}>
              <p>
                <strong>Login Type</strong>
              </p>
              <p style={{ textTransform: "capitalize" }}>{userDetail?.loginType}</p>
            </div>
          )}
          {userDetail?.lastLogin && (
            <div style={{ ...cardStyle, backgroundColor: "rgb(210 220 232)" }}>
              <p>
                <strong>Last Login</strong>
              </p>
              <p style={{ textTransform: "capitalize" }}>
                {" "}
                {moment(userDetail.lastLogin).format("ll")}
              </p>
            </div>
          )}
        </div>
        <div style={flexRow}>
          <div style={flexItem}>
            <h3>Delivery Address</h3>
            {userDetail?.userAddress == 0 && (
              <div style={cardStyle}>
                {" "}
                <p>No Address Yet!</p>
              </div>
            )}
            {userDetail?.userAddress &&
              userDetail?.userAddress?.map(
                e =>
                  e.isDefault && (
                    <div style={cardStyle}>
                      <p>
                        <strong>Name:</strong> {e.name}
                      </p>
                      {e.number && (
                        <p>
                          <strong>Number:</strong> {e.number}
                        </p>
                      )}
                      <p>
                        <strong>Address:</strong> {e.addressLine1 + e.addressLine2}
                      </p>
                      {e.department && (
                        <p>
                          <strong>Address:</strong> {e.department}
                        </p>
                      )}
                      {e.city && (
                        <p>
                          <strong>City:</strong> {e.city}
                        </p>
                      )}
                      {e.state && (
                        <p>
                          <strong>State:</strong> {e.state}
                        </p>
                      )}
                      {e.zipCode && (
                        <p>
                          <strong>Pincode:</strong> {e.zipCode}
                        </p>
                      )}
                      {e.country && (
                        <p>
                          <strong>Country:</strong> {e.country}
                        </p>
                      )}
                    </div>
                  )
              )}
          </div>
          <div style={flexItem}>
            <h3>Wishlists</h3>
            <div style={cardStyle}>
              {userDetail?.userWishlist?.length == 0 && <p>No Wishlist Yet!</p>}
              {userDetail?.userWishlist &&
                userDetail?.userWishlist?.map(e => (
                  <div
                    style={{
                      boxShadow: "0 0 4px 1px rgba(0,0,0,.1)",
                      borderRadius: "10px",
                      marginBottom: "10px",
                      padding: "10px 15px",
                    }}
                  >
                    <p>
                      <strong>Name:</strong> {e.name}
                    </p>
                    <p>
                      <strong>Number of products:</strong> {e.products?.length}
                    </p>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: "15px",
            background: "#fff",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ddd",
          }}
        >
          <h3 style={{ fontSize: "16px", fontWeight: "bold" }}>User Order</h3>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  ID
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Item
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Payment Info
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Order Date
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Price
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px", textAlign: 'center' }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {userOrderProduct?.length > 0 ? (
                userOrderProduct?.map(e => (
                  <tr>
                    <td
                      style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}
                    >
                      {e.invoiceId}
                    </td>
                    <td
                      style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}
                    >
                      {e?.orderedProducts?.length > 0 ? e?.orderedProducts?.length : "---"}
                    </td>
                    <td
                      style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}
                    >
                      {e?.paymentType}
                    </td>
                    <td
                      style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}
                    >
                      {moment(e.createdAt).format("ll")}
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        borderBottom: "1px solid #ddd",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      ₴{e?.totalPrice}
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        borderBottom: "1px solid #ddd",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Tooltip
                          title='View'
                          style={{ cursor: "pointer" }}
                          onClick={() => redirect(e)}
                        >
                          <RemoveRedEyeRoundedIcon />
                        </Tooltip>
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <div style={{ padding: "16px 0" }}>No order Yet!</div>
              )}
            </tbody>
          </table>
        </div>
        <div
          style={{
            marginTop: "15px",
            background: "#fff",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ddd",
          }}
        >
          <h3 style={{ fontSize: "16px", fontWeight: "bold" }}>Recent Visited Product</h3>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f5f5f5", textAlign: "left" }}>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Name
                </th>
                {/* <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Item
                </th> */}
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Rating
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Price
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px" }}>
                  Visit Date
                </th>
                <th style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "14px", textAlign: 'center' }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {userVisitProduct?.length > 0 ? (
                userVisitProduct?.map(e => (
                  <tr>
                    <td
                      style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}
                    >
                      {e?.product.nameEn}
                    </td>
                    {/* <td
                      style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}
                    >
                      {e?.orderedProducts?.length > 0 ? e?.orderedProducts?.length : "---"}
                    </td> */}
                    <td
                      style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}
                    >
                      {e?.product?.rating}
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        borderBottom: "1px solid #ddd",
                        fontSize: "12px",
                      }}
                    >
                      ₴{e?.product?.discountPrice}
                    </td>
                    <td
                      style={{ padding: "8px", borderBottom: "1px solid #ddd", fontSize: "12px" }}
                    >
                      {moment(e.createdAt).format("ll")}
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        borderBottom: "1px solid #ddd",
                        fontSize: "12px",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Tooltip
                          title='View'
                          style={{ cursor: "pointer" }}
                          onClick={() => reDirect(e)}
                        >
                          <RemoveRedEyeRoundedIcon />
                        </Tooltip>
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <div style={{ padding: "16px 0" }}>No Product Visit Yet!</div>
              )}
            </tbody>
          </table>
        </div>
        {/* <div style={cardStyle}>
        <h3>Order Summary</h3>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>Product Image</th>
              <th>Product Name</th>
              <th>Quantity</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><img src="oculus.jpg" alt="Oculus VR" width="50" /></td>
              <td>Oculus VR</td>
              <td>1</td>
              <td>$149.00</td>
            </tr>
            <tr>
              <td><img src="clock.jpg" alt="Wall Clock" width="50" /></td>
              <td>Wall Clock</td>
              <td>1</td>
              <td>$399.00</td>
            </tr>
          </tbody>
        </table>
      </div> */}
      </div>
      <Footer />
    </DashboardLayout>
  );
};

export default UserDetails;

// import React from "react";

// const UserDetails = () => {
//   const containerStyle = {
//     padding: "20px",
//     fontFamily: "Arial, sans-serif",
//     fontSize: "16px",
//   };

//   const cardStyle = {
//     padding: "15px",
//     borderRadius: "8px",
//     boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//     marginBottom: "15px",
//     fontSize: "16px",
//   };

//   const flexRow = {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "15px",
//   };

//   const flexItem = {
//     flex: "1 1 calc(50% - 15px)",
//     minWidth: "300px",
//     fontSize: "16px",
//   };

//   return (
//     <div style={containerStyle}>
//       <h2>User Details</h2>
//       <div style={flexRow}>
//         <div style={{ ...cardStyle, backgroundColor: "#f8d7da" }}>
//           <p><strong>Name</strong></p>
//           <p>Gabrielle</p>
//         </div>
//         <div style={{ ...cardStyle, backgroundColor: "#fff3cd" }}>
//           <p><strong>Email</strong></p>
//           <p>gabrielle.db@gmail.com</p>
//         </div>
//         <div style={{ ...cardStyle, backgroundColor: "#d1ecf1" }}>
//           <p><strong>Contact No</strong></p>
//           <p>202-906-12354</p>
//         </div>
//       </div>
//       <div style={flexRow}>
//         <div style={flexItem}>
//           <div style={cardStyle}>
//             <h3>Address</h3>
//             <p><strong>Block Number:</strong> A-510</p>
//             <p><strong>Address:</strong> 81 Fulton London</p>
//             <p><strong>Pincode:</strong> 385467</p>
//             <p><strong>Phone:</strong> 202-458-4568</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserDetails;
